import Vue from 'vue'
import './plugins/axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import ProductStoresMap from './components/ProductStoresMap2'
import ReceivingLocationsMap from './components/ReceivingLocationsMap'
import Geocoder from '@pderas/vue2-geocoder'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAVbI3LaCCt8nJI621VoZSkct8IotkvzZc',
    libraries: 'geometry,places'
  },
  installComponents: true
})
Vue.use(Geocoder, {
  defaultCountryCode: null, // e.g. 'CA'
  defaultLanguage: null, // e.g. 'en'
  defaultMode: 'address', // or 'lat-lng'
  googleMapsApiKey: 'AIzaSyAVbI3LaCCt8nJI621VoZSkct8IotkvzZc'
})

Vue.config.productionTip = false

Vue.component('ReceivingLocationsMap', ReceivingLocationsMap)
Vue.component('ProductStoresMap', ProductStoresMap)

new Vue({
  el: '#gerdauvmaps'
})
